export const defaultGtm = () => ({
	filter: {
		event: 'fac_button_click',
		category: 'vuejs-funil-vendas',
		action: 'click',
		label: 'Aplicar Filtros (sidebar)',
	},
	openFilter: {
		event: 'fac_button_click',
		category: 'vuejs-funil-vendas',
		action: 'click',
		label: 'Filtrar Dados',
	},
	clear: {
		event: 'fac_button_click',
		category: 'vuejs-funil-vendas',
		action: 'click',
		label: 'Limpar Filtros (sidebar)',
	},
})
